import { INotificationSetting } from '../interfaces';

export const notificationSettings: INotificationSetting[] = [
    {
        key: 'application_received',
        title: 'settings.notifications.applicationReceivedTitle',
        description:
            'settings.notifications.applicationReceivedDescription',
    }
];

export const defaultNotificationsSettingsFormValues = notificationSettings.reduce(
    (acc, setting) => {
        acc[setting.key] = {
            sms: false,
            email: false,
        };
        return acc;
    },
    {} as Record<string, { sms: boolean; email: boolean }>
);
